import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import {
    ClassNames,
    Color,
    forLifeOf,
    LifecycleAware,
    NavigationState
} from '@lsq-frontend/common-ui';
import { ClaimService, Icons, ResponsiveService } from '@lsq-frontend/common-ui';
import { Observable } from 'rxjs';
import { FeatureFlags } from '@lsq-frontend/fasttrack-shared/app-constants';
import { GlobalSearchService } from '../../global-search/global-search.service';
import { NotificationsService } from '../../notifications/notifications.service';
import { IdentityService } from '@lsq-frontend/fasttrack-shared/features/identity-service';
import {
    ClientSettingType,
    GetClientSettingRequest,
    GetClientSettingResponse,
    GetClientSettingService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';

@LifecycleAware()
@Component({
    selector: 'right-navigation-items',
    templateUrl: './right-navigation-items.component.html'
})
export class RightNavigationItemsComponent implements OnInit, OnDestroy {
    @Input() public navigationState: NavigationState;

    public hasGlobalSearchStream: Observable<boolean>;
    public topContentGlobalSearchClass = '';
    public isClientTerminated = false;

    public canHaveNotifications$ = this.claimService.isOn(DashboardClaim.FactoringDashboard);

    public readonly alertIcon = Icons.AlertError;
    public readonly claim = DashboardClaim;
    public readonly classNames = ClassNames;
    public readonly color = Color;
    public readonly icons = Icons;
    public readonly switchCompaniesIcon = Icons.SwitchCustomers;
    public readonly featureFlags = FeatureFlags;

    constructor(
        public responsiveService: ResponsiveService,
        public globalSearchService: GlobalSearchService,
        public notificationsService: NotificationsService,
        public claimService: ClaimService,
        public router: Router,
        public identityService: IdentityService,
        private _getClientSettingService: GetClientSettingService
    ) {}

    public ngOnInit(): void {
        this.globalSearchService.isExpanded$.pipe(forLifeOf(this)).subscribe((isExpanded) => {
            this.topContentGlobalSearchClass = isExpanded ? ClassNames.TopContentSearchBar : '';
        });
        this.identityService.companyName$.pipe(forLifeOf(this)).subscribe(() => {
            if (this.identityService.isArClient()) {
                const readOnlySettingRequest = new GetClientSettingRequest({
                    companyKey: this.navigationState?.user?.currentCompany?.companyKey,
                    clientSettingType: ClientSettingType.Terminated
                });
                this._getClientSettingService.execute(readOnlySettingRequest);
            }
        });

        this._getClientSettingService.dataStream
            .pipe(forLifeOf(this))
            .subscribe((response: GetClientSettingResponse) => {
                if (
                    response?.clientSetting?.clientSettingType === ClientSettingType.Terminated &&
                    this.navigationState?.user?.currentCompany?.companyKey ===
                        response?.clientSetting?.companyKey
                ) {
                    this.isClientTerminated = response?.clientSetting?.active;
                }
            });
    }

    public ngOnDestroy(): void {}

    public handleGlobalSearchToggle(isExpanded: boolean): void {
        if (isExpanded) {
            this.globalSearchService.expand();
        } else {
            this.globalSearchService.collapse();
        }
    }

    public toggleNotificationWindow(): void {
        this.notificationsService.toggleExpanded();
    }
}
